import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalNotification } from '@models/notifications/notification.model';
@Component({
  selector: 'gc-notification-detail',
  templateUrl: './notification-detail.component.html',
  styleUrls: ['./notification-detail.component.scss'],
  standalone: false,
})
export class NotificationDetailComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GlobalNotification,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
